
































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {
  Annotation,
  CanvasPosition,
  Option,
  SegmentationResource,
  State,
} from '@/types/gripper';
import {
  DeleteJobResourceCheckInput, JobInfo,
  JobInfo_job_task_parameter, UpdateJobResourceCheckInput,
} from '@/types/intrador';
import Konva from 'konva';

@Component({})
export default class ImageSegmentation extends Vue {
  @Prop(Object) public resource!: SegmentationResource;
  @Prop(Number) public brushSize!: number;
  @Prop(Boolean) public deleteMode!: boolean;
  @Prop(Array) public options!: Option[];
  @Prop(Object) private jobInfo!: JobInfo;
  @Prop(Object) private parameter!: JobInfo_job_task_parameter;
  @Prop(Object) private selectedParameterOption!: Option;
  @Prop(Number) private selectedAnnotation!: number;
  @Prop(Number) private zoom!: number;
  @Prop(Boolean) private drawBoxes!: boolean;
  @Prop(Number) private opacity!: number;

  private image: any = null;

  private imageCanvas: any = null;
  private imageContext: any = null;

  private canvas: any = null;
  private context: any = null;

  private drawCanvas: any = null;
  private drawContext: any = null;

  private annotationCanvas: any = null;
  private annotationContext: any = null;

  private annotations: Annotation[] = [];

  private stageWidth: number = 0;
  private stageHeight: number = 0;
  private imageWidth: number = 0;
  private imageHeight: number = 0;

  private isPaint = false;
  private lastPointerPosition: CanvasPosition = {x: 0, y: 0};
  private lastLine: CanvasPosition[] = [];

  private previousStates: State[] = [];

  private transform: DOMMatrix = new DOMMatrix();
  private stageScale: number = 1;

  private single = true;
  private previousSpread: number | null = null;

  public loadImage() {
    this.image = new Image();
    this.image.onload = () => {
      this.imageWidth = this.image.width;
      this.imageHeight = this.image.height;

      this.$emit('set-annotation', -1);

      this.imageCanvas = document.createElement('canvas');

      this.drawCanvas = document.createElement('canvas');
      this.drawCanvas.width = this.imageWidth;
      this.drawCanvas.height = this.imageHeight;
      this.drawContext = this.drawCanvas.getContext('2d') as CanvasRenderingContext2D;

      this.annotationCanvas = document.createElement('canvas');

      if (this.resource.check_value) {
        JSON.parse(this.resource.check_value).forEach((annotation: any) => {
          this.annotations.push(annotation);
        });
      }
      this.fitStageIntoWindow();
    };
  }

  public init(resource: any) {
    // const node = (this.$refs.stage as any).getNode() as Stage
    // node.attrs.width = 0;
    // node.attrs.height = 0;
    // node.bufferCanvas.width = 0;
    // node.bufferCanvas.height = 0;
    //
    // node.bufferHitCanvas.width = 0;
    // node.bufferHitCanvas.height = 0;
    //
    // (node.children as any).forEach( (child: any)=> {
    //   child.canvas.width = 0;
    //   child.canvas.height = 0;
    //   child.hitCanvas.width = 0;
    //   child.hitCanvas.height = 0;
    // })
    //
    // node.clearCache();
    // changing src of image suffices, because in created we have a image.onLoad function that takes care of the updates
    this.annotations = [];
    this.previousStates = [];
    this.lastLine = [];
    this.drawCanvas = null;
    this.drawContext = null;
    this.annotationCanvas = null;
    this.annotationContext = null;
    this.canvas = null;
    this.context = null;
    this.loadImage();
    this.image.src = resource.url;
    this.canvas = document.createElement('canvas');
    this.context = this.canvas.getContext('2d') as CanvasRenderingContext2D;
  }

  @Watch('selectedParameterOption')
  private onSelectedParameterOptionChange(option: Option) {
    if (this.selectedAnnotation >= 0 && option.id != null) {
      this.annotations[this.selectedAnnotation].category_id = parseInt(option.id, 0);
      this.persistToDatabase();
    }
    this.fitStageIntoWindow();
  }

  @Watch('selectedAnnotation')
  private onSelectedAnnotationChange() {
    if (this.selectedAnnotation >= 0) {
      const annotation = this.annotations[this.selectedAnnotation];
      const option = this.options.find((o: Option) => {
        return o.id != null && parseInt(o.id, 0) === annotation.category_id;
      });
      if (option) {
        this.$emit('change-option', option);
      }
    }
    this.fitStageIntoWindow();
  }

  private deleteSelectedAnnotation() {
    if (this.selectedAnnotation >= 0) {
      this.annotations.splice(this.selectedAnnotation, 1);
      this.persistToDatabase();
      this.$emit('set-annotation', -1);
      this.fitStageIntoWindow();
    } else if (this.annotations.length === 0) {
      this.clearState();
      this.resource.check_value = null;
      this.deleteValueOnDatabase();
      this.fitStageIntoWindow();
    }
  }

  private editSelectedAnnotation() {
    if (this.selectedAnnotation >= 0) {
      this.drawContext = this.drawCanvas.getContext('2d') as CanvasRenderingContext2D;
      const annotation = this.annotations.splice(this.selectedAnnotation, 1)[0];
      const imageData = new ImageData(annotation.segmentation.size[1], annotation.segmentation.size[0]);
      this.drawContext.putImageData(this.drawAnnotation(this.selectedAnnotation, annotation, imageData), 0, 0);
      this.drawImageToContext(this.context);

      this.persistToDatabase();
      this.$emit('set-annotation', -1);
      this.fitStageIntoWindow();
    }
  }


  private created() {
    this.loadImage();
    this.image.src = this.resource.url;
    this.canvas = document.createElement('canvas');
    this.context = this.canvas.getContext('2d') as CanvasRenderingContext2D;

    window.addEventListener('resize', this.fitStageIntoWindow);
  }

  private undo() {
    if (this.previousStates.length > 0) {
      const {imageData, line} = this.previousStates.pop() as State;
      this.lastLine = line;
      this.drawContext.clearRect(0, 0, this.imageWidth, this.imageHeight);
      this.drawContext.putImageData(imageData, 0, 0);
      this.drawImageToContext(this.context);
      this.refresh();
    }
  }

  private drawImageToContext(context: CanvasRenderingContext2D) {
    context.clearRect(0, 0, this.imageWidth, this.imageHeight);
    context.drawImage(this.drawCanvas, 0, 0);
  }

  private refresh() {
    (this.$refs.stage as any).getNode().batchDraw();
  }

  private startTouch(node: any) {
    if (node.evt.touches.length === 1) {
      this.single = true;
      const self = this;
      setTimeout(() => {
        if (self.single) {
          self.startPaint(node);
        }
      }, 50);
    } else {
      if (!this.isPaint) {
        this.single = false;
      }
    }
  }

  private endTouch(node: any) {
    if (this.single) {
      this.endPaint(node);
    }
    this.previousSpread = null;
  }

  private moveTouch(node: any) {
    if (this.single) {
      this.paint(node);
    } else if (node.evt.touches.length > 1) {
      const positions = node.target.getStage().getPointersPositions();
      const transform = this.transform;
      positions.forEach((pos: CanvasPosition) => {
        pos.x = Math.round((pos.x - transform.e) / transform.a);
        pos.y = Math.round((pos.y - transform.f) / transform.d);
        return pos;
      });

      const spread = Math.sqrt((positions[0].x - positions[1].x) ** 2 + (positions[0].y - positions[1].y) ** 2);
      if (this.previousSpread !== null) {
        const middle: CanvasPosition = {
          x: Math.round((positions[0].x + positions[1].x) / 2),
          y: Math.round((positions[0].y + positions[1].y) / 2),
        };
        let clicks = (spread - this.previousSpread) / 40;
        clicks = Math.max(clicks, -1);
        clicks = Math.min(clicks, 1);
        this.handleZoom(middle, clicks);
      }
      this.previousSpread = spread;
    }
  }

  private startPaint(node: any) {
    this.drawContext = this.drawCanvas.getContext('2d') as CanvasRenderingContext2D;
    this.saveState();

    if (this.selectedAnnotation >= 0) {
      this.$emit('set-annotation', -1);
    }

    // Setup draw
    this.isPaint = true;
    this.lastLine = [];
    this.lastPointerPosition = this.getPointerPosition(node);

    // Draw the initial point
    this.drawPoint(this.lastPointerPosition);

    // Show the changes
    this.drawImageToContext(this.context);
    this.refresh();
  }

  private paint(node: any) {
    if (!this.isPaint) {
      return;
    }

    // Get new position and draw a line between the old and new.
    const pos = this.getPointerPosition(node);
    this.drawLine(this.lastPointerPosition, pos);
    this.lastPointerPosition = pos;
    this.lastLine.push(pos);

    // Show the changes
    this.drawImageToContext(this.context);
    this.refresh();
  }

  private endPaint(node: any) {
    // Stop drawing
    this.isPaint = false;
  }

  private drawPoint(pos: CanvasPosition) {
    const radius = Math.ceil(this.brushSize / 2);
    const imageData = this.drawContext.getImageData(pos.x - radius, pos.y - radius, radius * 2, radius * 2);
    const R = this.deleteMode ? 0 : 24;
    const G = this.deleteMode ? 0 : 239;
    const B = this.deleteMode ? 0 : 159;
    let A = this.deleteMode ? 0 : this.opacity * 2.55;
    A = A * 1.7 > 255 ? 255 : A * 1.7;

    for (let x = 0; x < imageData.width; x++) {
      for (let y = 0; y < imageData.height; y++) {
        if ((x - radius) ** 2 + (y - radius) ** 2 <= radius ** 2) {
          const currentPos = (y * imageData.width) + x;
          imageData.data[currentPos * 4] = R;
          imageData.data[currentPos * 4 + 1] = G;
          imageData.data[currentPos * 4 + 2] = B;
          imageData.data[currentPos * 4 + 3] = A;
        }
      }
    }
    this.drawContext.putImageData(imageData, pos.x - radius, pos.y - radius);
  }

  private drawLine(pos1: CanvasPosition, pos2: CanvasPosition) {
    const radius = Math.floor(this.brushSize / 2);

    const minX = Math.min(pos1.x, pos2.x) - radius;
    const minY = Math.min(pos1.y, pos2.y) - radius;

    const imageData = this.drawContext.getImageData(
      minX,
      minY,
      radius * 2 + Math.abs(pos1.x - pos2.x),
      radius * 2 + Math.abs(pos1.y - pos2.y),
    );

    const R = this.deleteMode ? 0 : 24;
    const G = this.deleteMode ? 0 : 239;
    const B = this.deleteMode ? 0 : 159;
    let A = this.deleteMode ? 0 : this.opacity * 2.55;
    A = A * 1.7 > 255 ? 255 : A * 1.7;

    for (let x = 0; x < imageData.width; x++) {
      for (let y = 0; y < imageData.height; y++) {
        const point = {x: x + minX, y: y + minY} as CanvasPosition;
        if (this.getSquaredDistanceToLineSegment(point, pos1, pos2) <= radius ** 2) {
          const pos = (y * imageData.width) + x;
          imageData.data[pos * 4] = R;
          imageData.data[pos * 4 + 1] = G;
          imageData.data[pos * 4 + 2] = B;
          imageData.data[pos * 4 + 3] = A;
        }
      }
    }
    this.drawContext.putImageData(imageData, minX, minY);
  }

  private getSquaredDistanceToLineSegment(point: CanvasPosition, pos1: CanvasPosition, pos2: CanvasPosition) {
    const dX = pos2.x - pos1.x;
    const dY = pos2.y - pos1.y;

    const dot = (point.x - pos1.x) * dX + (point.y - pos1.y) * dY;
    const len = dX ** 2 + dY ** 2;
    let param = -1;
    if (len !== 0) {
      param = dot / len;
    }

    let xx = pos1.x;
    let yy = pos1.y;

    if (param > 1) {
      xx = pos2.x;
      yy = pos2.y;
    } else if (param > 0) {
      xx += param * dX;
      yy += param * dY;
    }

    return (point.x - xx) ** 2 + (point.y - yy) ** 2;
  }

  private saveState() {
    this.previousStates.push({
      imageData: this.drawContext.getImageData(0, 0, this.imageWidth, this.imageHeight),
      line: this.lastLine,
    } as State);
  }

  private clearState() {
    this.drawContext.clearRect(0, 0, this.imageWidth, this.imageHeight);
    this.previousStates = [];
    this.lastLine = [];
  }

  private save() {
    const imageData = this.drawContext.getImageData(0, 0, this.imageWidth, this.imageHeight);
    const annotation = this.toAnnotation(imageData);

    if (annotation.area) {
      this.clearState();
      this.annotations.push(annotation);
    }

    this.persistToDatabase();
    this.$emit('set-annotation', this.annotations.length - 1);
  }

  private drawBoundingBox(index: number, annotation: Annotation) {
    if (annotation.bbox && this.drawBoxes) {
      // Draw bounding box:
      this.drawContext.globalCompositeOperation = 'source-over';
      this.drawContext.strokeStyle = index === this.selectedAnnotation ? 'green' : '#000';
      this.drawContext.lineWidth = 1;
      this.drawContext.beginPath();
      this.drawContext.rect(annotation.bbox[0], annotation.bbox[1], annotation.bbox[2], annotation.bbox[3]);
      this.drawContext.stroke();

      // Get category display value
      const category = this.options.find((option: Option) => {
        return option.id != null && parseInt(option.id, 0) === annotation.category_id;
      });
      const display = ' ' + index + ': ' + ((category?.value || annotation.category_id) as string);
      // Display category with white background for better readability
      const width = this.drawContext.measureText(display).width;
      const height = 10;
      this.drawContext.font = 'bold 10px verdana';
      this.drawContext.fillStyle = 'rgba(255,255,255,0.5)';
      this.drawContext.beginPath();
      this.drawContext.rect(annotation.bbox[0], annotation.bbox[1], width + 18, height + 4);
      this.drawContext.fill();
      this.drawContext.stroke();

      this.drawContext.fillStyle = '#000';
      this.drawContext.fillText(display, annotation.bbox[0] + 3, annotation.bbox[1] + height + 1);
    }
  }

  private toAnnotation(imageData: ImageData): Annotation {
    const {data, width, height} = imageData;
    const counts: number[] = [];
    let count: number = 0;
    let pixel: boolean = false;
    let yMin = height;
    let yMax = 0;

    for (let x = 0; x < width; x++) {
      for (let y = 0; y < height; y++) {
        const i = y * width + x;
        // If the current pixel is empty
        if (pixel !== (data[i * 4] === 0 && data[i * 4 + 1] === 0 && data[i * 4 + 2] === 0)) {
          count++;
        } else {
          pixel = !pixel;
          if (pixel) {
            yMin = Math.min(yMin, y);
          } else if (y >= count) {
            yMax = Math.max(yMax, y);
          } else if (y === 0) {
            yMax = height;
          } else {
            yMax = height;
            yMin = 0;
          }
          counts.push(count);
          count = 1;
        }
      }
    }

    counts.push(count);

    // Count the area of the segment;
    const area = counts.reduce((a, v, index) => {
      return a + (index % 2 === 1 ? v : 0);
    }, 0);

    const xMin = Math.floor(counts[0] / height);
    const boxWidth = width - Math.floor(count / height) - xMin;
    const boxHeight = yMax - yMin;

    return {
      image_id: Number(this.resource.id),
      category_id: Number(this.selectedParameterOption?.id),
      category_name: this.selectedParameterOption?.value || '',
      segmentation: {
        size: [(height as number), (width as number)],
        counts: this.countsToRLE(counts),
      },
      area,
      bbox: [
        xMin, yMin, boxWidth, boxHeight,
      ],
    } as Annotation;
  }

  /* tslint:disable:no-bitwise */
  private countsToRLE(counts: number[]): string {
    let s = '';
    for (let i = 0; i < counts.length; i++) {
      let x = counts[i];
      if (i > 2) {
        x -= counts[i - 2];
      }
      let more = true;
      while (more) {
        let c = x & 0x1f;
        x >>= 5;
        more = c & 0x10 ? x !== -1 : x !== 0;
        if (more) {
          c |= 0x20;
        }
        c += 48;
        s += String.fromCharCode(c);
      }
    }
    return s;
  }

  private RLEToCounts(s: string): number[] {
    const counts: number[] = [];
    let more: number = 0;
    let x: number = 0;
    let k: number = 0;

    for (let i: number = 0; i < s.length; i++) {
      let c: number = s.charCodeAt(i);
      if (!c) {
        continue;
      }
      c -= 48;
      x |= (c & 0x1f) << 5 * k;
      more = c & 0x20;
      k++;
      if (more === 0 && (c & 0x10)) {
        x |= -1 << 5 * k;
      }
      if (more === 0) {
        if (counts.length > 2) {
          x += counts[counts.length - 2];
        }
        counts.push(x);
        x = 0;
        k = 0;
      }
    }
    return counts;
  }

  /* tslint:enable:no-bitwise */

  private drawAnnotation(index: number, annotation: Annotation, imageData: ImageData): ImageData {
    const isCurrentCategory = annotation.category_id === Number(this.selectedParameterOption?.id);
    const isSelectedAnnotation = index === Number(this.selectedAnnotation);

    const R = isCurrentCategory ? 24 : 125;
    const G = isCurrentCategory ? 239 : 120;
    const B = isCurrentCategory ? 159 : 255;
    const A = this.opacity * (isSelectedAnnotation ? 2.55 : 2.0);

    const counts = this.RLEToCounts(annotation.segmentation.counts);

    let j = 0;
    let k = 0;
    let draw = false;
    for (let x = 0; x < imageData.width; x++) {
      for (let y = 0; y < imageData.height; y++) {
        if (counts[k] === j) {
          draw = !draw;
          j = 1;
          k++;
        } else {
          j++;
        }
        if (draw) {
          const i = y * imageData.width + x;
          imageData.data[i * 4] = R;     // R
          imageData.data[i * 4 + 1] = G;  // G
          imageData.data[i * 4 + 2] = B;   // B
          imageData.data[i * 4 + 3] = A;  // A
        }
      }
    }

    return imageData;
  }

  private fillLastPath() {
    this.drawContext = this.drawCanvas.getContext('2d') as CanvasRenderingContext2D;

    this.saveState();

    this.drawLine(this.lastLine[this.lastLine.length - 1], this.lastLine[0]);

    // Start the path
    this.drawContext.beginPath();
    this.drawContext.moveTo(this.lastLine[0].x, this.lastLine[0].y);

    // Redraw the previous line
    this.lastLine.forEach((pos) => {
      this.drawContext.lineTo(pos.x, pos.y);
    });

    // Close the path and fill it
    this.drawContext.closePath();

    // fill path
    this.drawContext.fillStyle = this.deleteMode ? '#000' : 'rgba(24, 239, 159, 0.75)';
    this.drawContext.globalCompositeOperation = this.deleteMode ? 'destination-out' : 'source-over';
    this.drawContext.fill();

    // Redraw to annotation and back to have a clear mask rather than overlapping alpha's
    const annotation = this.toAnnotation(
      this.drawContext.getImageData(0, 0, this.imageWidth, this.imageHeight),
    );
    const imageData = new ImageData(annotation.segmentation.size[1], annotation.segmentation.size[0]);
    this.drawContext.putImageData(this.drawAnnotation(-1, annotation, imageData), 0, 0);

    this.drawImageToContext(this.context);
    this.refresh();
  }

  private getPointerPosition(node: any): CanvasPosition {
    const pos = node.target.getStage().getPointerPosition();
    pos.x = Math.round((pos.x - this.transform.e) / this.transform.a);
    pos.y = Math.round((pos.y - this.transform.f) / this.transform.d);
    this.lastLine.push(pos);
    return pos;
  }

  private handleZoom(pt: CanvasPosition, clicks: number) {
    if (pt !== null) {
      pt.x = Math.round((pt.x - this.transform.e) / this.transform.a);
      pt.y = Math.round((pt.y - this.transform.f) / this.transform.d);

      const factor = Math.pow(1.1, clicks);
      this.imageContext.translate(pt.x, pt.y);
      this.imageContext.scale(factor, factor);
      this.imageContext.translate(-pt.x, -pt.y);

      this.transform = this.imageContext.getTransform();

      this.transform.a = Math.max(this.transform.a, this.stageScale);
      this.transform.d = Math.max(this.transform.d, this.stageScale);
      this.transform.e = Math.min(
        Math.max(this.transform.e, -1 * this.transform.a * this.imageWidth + this.stageWidth),
        0);
      this.transform.f = Math.min(
        Math.max(this.transform.f, -1 * this.transform.d * this.imageHeight + this.stageHeight),
        0);

      this.imageContext.setTransform(this.transform);

      this.imageContext.drawImage(this.image, 0, 0);

      this.drawContext = this.drawCanvas.getContext('2d') as CanvasRenderingContext2D;
      const currentImageData = this.drawContext.getImageData(0, 0, this.imageWidth, this.imageHeight);
      // Get current mask and save it temporarily
      const annotationImageData = new ImageData(this.imageWidth, this.imageHeight);
      this.drawContext.putImageData(annotationImageData, 0, 0);

      if (this.annotations.length > 0) {
        // For every annotation, draw the annotation to the corresponding canvas.
        this.annotations.forEach((annotation, index) => {
          this.drawAnnotation(index, annotation, annotationImageData);
        });
        this.drawContext.putImageData(annotationImageData, 0, 0);
        this.annotations.forEach((annotation, index) => {
          this.drawBoundingBox(index, annotation);
        });

      }

      this.annotationContext.setTransform(this.transform);

      this.drawImageToContext(this.annotationContext);

      // Reset the drawContext to be equal to the current annotation
      this.drawContext.clearRect(0, 0, this.imageWidth, this.imageHeight);
      this.drawContext.putImageData(currentImageData, 0, 0);

      // Scale and redraw the current annotation to the canvas
      this.context.setTransform(this.transform);

      this.drawImageToContext(this.context);


      this.refresh();
    }
  }

  private handleScroll(x: any) {
    const delta = x.evt.wheelDelta ? x.evt.wheelDelta / 40 : x.evt.detail ? -x.evt.detail : 0;
    if (delta) {
      this.handleZoom(x.currentTarget.getPointerPosition(), delta);
    }
    return x.evt.preventDefault() && false;
  }

  @Watch('zoom')
  @Watch('drawBoxes')
  private async fitStageIntoWindow() {
    // Get new sizes and scales
    this.stageWidth = window.innerWidth - 100;
    this.stageHeight = window.innerHeight - 270;
    this.stageScale = Math.min(this.stageWidth / this.imageWidth, this.stageHeight / this.imageHeight);
    this.stageWidth = Math.round(this.imageWidth * this.stageScale);
    this.stageHeight = Math.round(this.imageHeight * this.stageScale);

    this.imageCanvas.width = this.stageWidth;
    this.imageCanvas.height = this.stageHeight;

    this.imageContext = this.imageCanvas.getContext('2d') as CanvasRenderingContext2D;
    this.imageContext.scale(this.stageScale, this.stageScale);
    this.imageContext.drawImage(this.image, 0, 0);

    this.transform = this.imageContext.getTransform();

    const currentImageData = this.drawContext.getImageData(0, 0, this.imageWidth, this.imageHeight);
    // Get current mask and save it temporarily
    const annotationImageData = new ImageData(this.imageWidth, this.imageHeight);
    this.drawContext.putImageData(annotationImageData, 0, 0);

    if (this.annotations.length > 0) {
      // For every annotation, draw the annotation to the corresponding canvas.
      this.annotations.forEach((annotation, index) => {
        this.drawAnnotation(index, annotation, annotationImageData);
      });
      this.drawContext.putImageData(annotationImageData, 0, 0);
      this.annotations.forEach((annotation, index) => {
        this.drawBoundingBox(index, annotation);
      });

    }
    this.annotationCanvas.width = this.stageWidth;
    this.annotationCanvas.height = this.stageHeight;

    this.annotationContext = this.annotationCanvas.getContext('2d') as CanvasRenderingContext2D;

    this.annotationContext.setTransform(this.transform);

    this.drawImageToContext(this.annotationContext);

    this.transform = this.annotationContext.getTransform();

    // Reset the drawContext to be equal to the current annotation
    this.drawContext.clearRect(0, 0, this.imageWidth, this.imageHeight);
    this.drawContext.putImageData(currentImageData, 0, 0);

    // Scale and redraw the current annotation to the canvas
    this.canvas.width = this.stageWidth;
    this.canvas.height = this.stageHeight;

    this.context.setTransform(this.transform);

    this.drawImageToContext(this.context);

    // Redraw everything.
    this.refresh();
  }

  private async persistToDatabase() {
    this.resource.check_value = JSON.stringify(this.annotations);

    const variables: UpdateJobResourceCheckInput = {
      job_id: this.jobInfo!.job!.id,
      resource_id: this.resource.id.toString(),
      value: this.resource.check_value,
      option_id: null,
    } as UpdateJobResourceCheckInput;
    if (variables !== undefined) {
      this.$apollo.mutate({
        mutation: require('@/graphql/mutations/UpdateJobResourceCheck.graphql'),
        variables: {input: variables},
      }).catch((error) => {
        this.$swal('Error', error.message, 'warning');
      });
    }
  }

  private async deleteValueOnDatabase() {
    const variables: DeleteJobResourceCheckInput = {
      job_id: this.jobInfo!.job!.id,
      resource_id: this.resource.id.toString(),
    } as DeleteJobResourceCheckInput;
    this.$apollo.mutate({
      mutation: require('@/graphql/mutations/DeleteJobResourceCheck.graphql'),
      variables: {input: variables},
    }).catch((error) => {
      this.$swal('Error', error.message, 'warning');
    });
  }

  @Watch('opacity')
  private opacityChanged() {
    /*** change the opacity for the current annotation that is being made *****/
    const imageData = this.drawContext.getImageData(0, 0, this.imageWidth, this.imageHeight);

    let A = this.deleteMode ? 0 : this.opacity * 2.55;
    // Make sure that our currently drawing data is of a somewhat higher opacity then the already existing annotations
    // We increase the opacity with 70% of the active drawing
    A = A * 1.7 > 255 ? 255 : A * 1.7;

    for (let x = 0; x < imageData.width; x++) {
      for (let y = 0; y < imageData.height; y++) {
        const pos = (y * imageData.width) + x;
        if (imageData.data[pos * 4] !== 0 || imageData.data[pos * 4 + 1] !== 0 || imageData.data[pos * 4 + 2] !== 0) {
          imageData.data[pos * 4 + 3] = A;
        }
      }
    }
    this.drawContext.putImageData(imageData, 0, 0);

    // Update the other already done annotations that were persisted
    this.fitStageIntoWindow();
  }


}
